var map = {
	"./Home.vue": [
		6764
	],
	"./Notification.vue": [
		4287,
		287
	],
	"./Notifications.vue": [
		7428
	],
	"./account/Assigns.vue": [
		1165
	],
	"./account/Groups.vue": [
		8307
	],
	"./helper/Modal.vue": [
		6980
	],
	"./menu_and_permissions/ModuleOrMenu.vue": [
		9186
	],
	"./menu_and_permissions/PermissionAction.vue": [
		7691
	],
	"./page/Area.vue": [
		6477,
		477
	],
	"./page/ChatRoom.vue": [
		173
	],
	"./page/ChatRoomBackup31624.vue": [
		9246,
		246
	],
	"./page/ChatRoomBackup61623.vue": [
		9556,
		556
	],
	"./page/ChatRoomOld.vue": [
		7742,
		742
	],
	"./page/Conversations.vue": [
		2599
	],
	"./page/Coupons.vue": [
		2101
	],
	"./page/Customers.vue": [
		9356
	],
	"./page/Districts.vue": [
		7730
	],
	"./page/Login.vue": [
		3792
	],
	"./page/ProductCategory.vue": [
		915
	],
	"./page/ProductType.vue": [
		5750
	],
	"./page/Profile.vue": [
		2889
	],
	"./page/Role.vue": [
		6934
	],
	"./page/RolePermission.vue": [
		637
	],
	"./page/SaleAdd.vue": [
		5618
	],
	"./page/Sales.vue": [
		8711
	],
	"./page/SalesPending.vue": [
		2185,
		185
	],
	"./page/Sliders.vue": [
		4219
	],
	"./page/SubscriptionRequests.vue": [
		7581
	],
	"./page/SupportGroup.vue": [
		5134,
		134
	],
	"./page/User.vue": [
		8810
	],
	"./product/Product.vue": [
		5879
	],
	"./report/ProductGroupReport.vue": [
		8773,
		773
	],
	"./report/SalesReport.vue": [
		8363,
		363
	],
	"./report/WithdrawRequest.vue": [
		3242,
		242
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;